var Laroute = require('../../../laroute');

module.exports = function(h, row, that) {
    var datesFilter = {
        since: that.$store.getters.startDate.format(),
        until: that.$store.getters.endDate.format(),
    };

    var href = Laroute.route(
        'franchise.report.staff_attendance.export_attendance_individual',
        {
            staff_id: row.staff_id,
            type: 'PDF',
        },
    );

    href += `?${$.param(datesFilter)}`;

    return (
        <a href={href} target="_blank">
            <i class="material-icons">&#xE2C4;</i>
        </a>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/staff-attendance/export-staff-summary.jsx